
<template>
  <div></div>
</template>

<style scoped>

</style>
<script>
import {getImei, readCommonParam} from "@/util/session-storage-utils";
import {navigateToDeviceCall, navigateToIndex} from "@/util/jsinterfaces-util";
export default {
  name: "CallIndex",
  created(){
    readCommonParam(this)
    navigateToDeviceCall(getImei())
    // document.title = this.$t("");
  },
  mounted(){
    document.addEventListener('visibilitychange', this.getHiddenStatus, true);
  },
  data(){
    return {
      hidden:false
    }
  },
  methods:{
    getHiddenStatus() {
      const isHidden = document.hidden;
      if (isHidden) {
        this.hidden = true
      } else {
        if(this.hidden){
          navigateToIndex(getImei())
        }
      }
    }
  }
}
</script>
